import LevelMap from './LevelMap'
import classNames from 'classnames'
import styles from './Heading.module.css'
import { type HeadingProps } from './types'
import { LayoutStack } from '../layouts'
import { useId } from 'react'

function Heading({
  as,
  level,
  children,
  subtitle,
  className,
  flex,
  ['aria-describedby']: ariaDescribedBy,
  ...props
}: HeadingProps) {
  const Tag = as || LevelMap[level]
  const subtitleId = useId()

  return (
    <LayoutStack space="50">
      <Tag
        {...props}
        className={classNames(styles[level], className, { [styles.flex!]: flex })}
        aria-describedby={subtitle ? subtitleId : ariaDescribedBy}
      >
        {children}
      </Tag>
      {subtitle ? (
        <div id={subtitleId} aria-hidden={true}>
          {subtitle}
        </div>
      ) : null}
    </LayoutStack>
  )
}

export default Heading
